export default {
  text: '将文件拖到此处，或<em>点击上传</em>',
}
